import React, {useState} from 'react';
import {Button, Menu, MenuItem} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
/*import './ActionButton.css';*/
import {handleAddPosition} from "@portfolio/gridcomponents/util/GridOperations";
import {useSharingContext} from '../../../contexts/SharingContext';
import {useDelayedTickContext} from "../../context/DelayedTickContext";
import {useInstrumentRowContext} from "@dashboard/contexts/InstrumentRowContext";
import {handleShowDetails} from '../Portfoliorow/MoreDetails/MoreDetailsOperations';
import { useAnnouncementContext } from '../../../contexts/ExchangeAnnContext';
import {
    handleShowAnnouncements,
    handleShowAnnouncementsPF
} from "@dashboard/grid-components/announcements/AnnouncementUtil";
import {tickStorage} from "@dashboard/contexts/tickStore";

const ActionButtonsWrapper = ({ onShowChart }) => {
    return <ActionButtons onShowChart={onShowChart} />;
};

const ActionButtons = React.memo(({delayedTick,onShowChart}) => {
    const {
        currentlyHeldPositions,
        setCurrentlyHeldPositions,
        PosGridlayouts,
        setPosGridlayouts,
        PosGridTabID
    } = useSharingContext();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const { announcements, newAnnouncements,isUnmounting,setIsUnmounting } = useAnnouncementContext();
    const {
        uniqueId,
        stock,
        aggregatedSortedStocksCurrentClientTab,
        setAggregatedSortedStocksCurrentClientTab,
        setLayouts,
        tabID,
        layouts,
        index,
        listRef,
        rowVirtualizer,
        pauseAutoRefreshForMs,
        patchFrozenSnapshotInstrumentEntity,
        toggleAnnouncementStocksOnly,
        announcementStocksOnly
    } = useInstrumentRowContext();
    const handleClick = (event) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);  // use actual button DOM element
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        /*<div className="actionsSTAGC-pf">*/
        <div className={`actionsPF ${anchorEl ? 'show-actions' : ''}`}>
            <Button variant="contained" color="primary">B</Button>
            <Button variant="contained" color="secondary">S</Button>
            <Button
                variant="contained"
                sx={{ backgroundColor: '#4caf50', color: 'white' }}
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => {
                    const tick = tickStorage.latest[stock.instrumentEntity.instrumentToken]; // ✅ grab current tick
                    handleAddPosition(
                        stock.instrumentEntity,
                        setLayouts,
                        tabID,
                        tick, // ✅ pass it directly
                        setCurrentlyHeldPositions,
                        PosGridlayouts,
                        setPosGridlayouts,
                        PosGridTabID
                    );
                }}
                disabled={currentlyHeldPositions.some(
                    (position) => position.instrumentToken === stock.instrumentEntity.instrumentToken
                )}
            >
                P
            </Button>
            <Button
                variant="contained"
                color="default"
                className="small-button"
                onMouseDown={(event) => event.stopPropagation()}
                onClick={() => handleShowDetails(aggregatedSortedStocksCurrentClientTab,stock.instrumentEntity, setLayouts, tabID, index,rowVirtualizer)}
            >
                <DensitySmallIcon sx={{fontSize: 16}}/>
            </Button>
            <Button
                variant="contained"
                color="default"
                className="small-button"
                onClick={handleClick}
            >
                <MoreHorizIcon sx={{fontSize: 22}}/>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
            >
                {/*<MenuItem onClick={(e) => {
                    e.currentTarget.blur();
                    if (typeof toggleAnnouncementStocksOnly === 'function') {
                        toggleAnnouncementStocksOnly();
                    }
                    handleClose();
                }}>
                    {announcementStocksOnly ? 'Show all stocks' : 'Announcement only stocks'}
                </MenuItem>*/}

                <MenuItem onClick={(e) => {
                    e.currentTarget.blur(); // ✅ Remove focus from menu item to prevent aria-hidden trap
                    onShowChart(stock.instrumentToken,stock.instrumentEntity.tradingsymbol);
                    handleClose();
                }}>
                    Chart
                </MenuItem>
                <MenuItem onClick={(e) => {
                    e.currentTarget.blur(); // ✅ Remove focus from menu item to prevent aria-hidden trap
                    if (typeof pauseAutoRefreshForMs === 'function') {
                        pauseAutoRefreshForMs(4 * 60 * 1000, { freezeImmediately: false, thawExistingFreeze: true });
                    }
                    handleShowAnnouncementsPF(stock.instrumentEntity, setAggregatedSortedStocksCurrentClientTab, setLayouts, tabID, layouts, index, announcements, newAnnouncements,setIsUnmounting,listRef);

                    // If we're currently showing a frozen snapshot (announcement-only / not-refreshing),
                    // the table may still be rendering from that snapshot array. Patch the snapshot to
                    // reflect the user-triggered toggle so the AnnouncementList actually appears.
                    if (typeof patchFrozenSnapshotInstrumentEntity === 'function') {
                        patchFrozenSnapshotInstrumentEntity(
                            stock.instrumentEntity?.instrumentToken,
                            { forceShowAnnouncements: true }
                        );
                    }
                    handleClose();
                }}>
                    Announcements
                </MenuItem>

            </Menu>
            {/*</DelayedTickProvider>*/}
        </div>
    );
}, areEqual); // 👈 Add custom comparison function


function areEqual(prev, next) {
    return JSON.stringify(prev.delayedTick) === JSON.stringify(next.delayedTick);
}

export default ActionButtonsWrapper;
